import './App.css';
import Home from './pages/Home';
import SignIn from './pages/SignIn';
import Dashboard from "./pages/Dashboard";
import WheelCalculator from './pages/WheelCalculator'
import LinearDecomposer from './pages/LinearDecomposer';
// import Settings from './pages/Settings';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import PrivateRoute from "./utils/PrivateRoute";
import GlassFinderPerCompany from "./components/LinearDecomposer/GlassFinderPerCompany";
import SponsorManufacturer from "./pages/SponsorManufacturer";
import ConnectionTest from "./pages/ConnectionTest";

import AdminRoute from './utils/AdminRoute';
import AdminPage from './pages/admin/AdminPage';

function App() {
    return (
        <Router>
            <div className="App">
                <Routes>
                    {/* Public routes */}
                    <Route path="/" element={<Home />} />
                    <Route path="/signin" element={<SignIn />} />
                    <Route path="/sponsor/:company" element={<SponsorManufacturer />} />
                    {/* <Route path="/connection-test" element={<ConnectionTest />} /> */}
                    {/* Protected routes wrapped with Layout */}
                    <Route
                        element={
                            <PrivateRoute>
                                <Layout /> {/* Wrap protected routes with Layout */}
                            </PrivateRoute>
                        }
                    >
                        <Route path="/dashboard" element={<Dashboard />} />
                        {/* <Route path="/wheelcalculator" element={<WheelCalculator />} /> */}
                        <Route path="/lineardecomposer" element={<LinearDecomposer />} />
                        {/* <Route path="/settings" element={<Settings />} /> */}
                        <Route path="/glass-finder-per-company" element={<GlassFinderPerCompany />} />

                        <Route
                            path="/admin"
                            element={
                                <AdminRoute>
                                    <AdminPage />
                                </AdminRoute>
                            }
                        />
                    </Route>
                </Routes>
            </div>
        </Router>
    );
}

export default App;
